export default __webpack_public_path__ + "static/media/location-efefef-18px.7cc9618b.svg";